import React from 'react';

export default function ConfigLoading({ block, updateBlock, nodes, node, updateNode }) {

    if(block.destinationType === null){
        block.destinationType = 'step';
        block.target = null;
        updateBlock(block.id, 'destinationType', 'step');
      
    }
    
    function handleDestinationTypeChange(e) {
        block.destinationType = e.target.value;
        updateBlock(block.id, 'destinationType', e.target.value);
    }
    function handleTargetChange(e) {
        block.target = e.target.value;
        updateBlock(block.id, 'target', e.target.value);
    }
 
 
    return (
        <div className="flex flex-col gap-2 w-full">
            <label className="block font-semibold mb-2 w-full"     >Título:</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <input type="text" value={block.title } onChange={(e) => updateBlock(block.id, 'title', e.target.value)} />
            </div>
            <label className="block font-semibold mb-2 w-full"     >Duração (em segundos):</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <input type="number" value={block.duration || 3000} onChange={(e) => updateBlock(block.id, 'duration', e.target.value)} />
            </div>
         
            <label className="block font-semibold mb-2 w-full"     >Descrição:</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <input type="text" value={block.description} onChange={(e) => updateBlock(block.id, 'description', e.target.value)} className="w-full" />
            </div>

            <label className="block font-semibold mb-2 w-full">Redirecionar para:</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <select className="w-full"
                    value={block.destinationType || 'step'}
                    onChange={(e) => updateBlock(block.id, 'destinationType', e.target.value)}
                >
                    <option value="step">Etapa</option>
                    <option value="url">URL</option>
                </select>
            </div>
            {block.destinationType === 'url' && (
                <>
                    <label className="block font-semibold mb-2 w-full">URL de destino:</label>
                    <div className="p-2 bg-gray-100 rounded w-full h-full">
                        <input
                            type="text"
                            value={block.url || ''}
                            onChange={(e) => updateBlock(block.id, 'url', e.target.value)}
                            placeholder="https://exemplo.com"
                            className="w-full"
                        />
                    </div>
                </>
            )}
            {block.destinationType === 'step' && (
                <>
                    <label className="block font-semibold mb-2 w-full">Etapa de destino:</label>
                    <div className="p-2 bg-gray-100 rounded w-full h-full">
                        <select className="w-full" value={block.target || ''} onChange={(e) => updateBlock(block.id, 'target', e.target.value)}>
                            {nodes.map((node) => (
                                <option value={node.id} className="text-black">{node.data.title}</option>
                            ))}
                        </select>
                    </div>
                </>
            )}
            

            <label className="block font-semibold mb-2 w-full"     >Cor:</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <select value={block.color || 'blue'} onChange={(e) => updateBlock(block.id, 'color', e.target.value)} className="w-full">
                    <option value="blue">Azul</option>
                    <option value="red">Vermelho</option>
                    <option value="green">Verde</option>
                    <option value="yellow">Amarelo</option>
                    <option value="purple">Roxo</option>
                </select>
            </div>

        </div>
    );
}